import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { v4 } from 'uuid';

const SelectOption = (props) => {
    const {
    callBackFn, classname, data, obj, mainValue, refValue, title
    } = props;

    const [slctd, setSlctd] = useState('');

    const handleSelect = (e) => {
        const { value } = e.target;
        if (value.includes('-Select')) {
            setSlctd('');
            callBackFn('');
        } else {
            setSlctd(e.target.value);
            callBackFn(e.target.value);
        }
        // if (refValue.current !== slctd) {
        //     console.log(refValue);
        //     setSlctd(e.target.value);
        //     refValue.current = slctd;
        //     callBackFn(e.target.value);
        // }
        // refValue.current = slctd;
        // callBackFn(e.target.value);
    };

    const iterateData = (data, obj) => {
        if (obj) {
            return data.map((i) => (
                <option key={v4()} value={i[obj]}>{i[obj]}</option>
            ));
        }
        return data.map((i) => (
            <option key={v4()} value={i}>{i}</option>
        ));
    };

    return (
        <>
            {/* <label htmlFor={title}>{title}</label> */}
            <select
              className={classname}
              ref={refValue}
              value={slctd}
              onKeyDown={(e) => e.preventDefault()}
              onChange={handleSelect}
            >
                <option value={null}>
                -
                    {title}
                -
                </option>
                {iterateData(data, obj)}
            </select>
        </>
    );
};

SelectOption.propTypes = {
    callBackFn: PropTypes.func.isRequired,
    classname: PropTypes.string,
    data: PropTypes.arrayOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.object])
        ).isRequired,
    obj: PropTypes.string,
    refValue: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    title: PropTypes.string.isRequired
};

export default SelectOption;
